import styles from '../styles/TermsAndConditions.module.css';
import { getConfiguration } from '../merchantConfig';

//
//

type TermsAndConditionsProps = {
  merchantCode: string;
};

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ merchantCode }) => {
  const config = getConfiguration(merchantCode);

  if (!config?.termsAndConditionsHtml) {
    return null;
  }

  return (
    <p
      className={styles.privacyPolicy}
      dangerouslySetInnerHTML={{ __html: config.termsAndConditionsHtml }}
    />
  );
};
